/* BASEURLS */

export const IGAST_BASEURL = `https://api.igap.net/ati-shahr/v1.0`;
export const FILE_BASEURL = `https://gate.igap.net/files/v1.0`;
export const STICKER_BASEURL = "https://api.igap.net/sticker/v1.0";
export const ILAND_BASEURL = "https://api.igap.net/operator-services/v1.0";
export const PAYMENT_BASEURL = "https://api.igap.net/payment/v3.0";
export const SERVICES_BASEURL = "https://api.igap.net/services/v1.0";
export const EXTERNAL_BASEURL = "https://api.igap.net/external/v1.0";
export const PEC_QR_BASEURL = "https://api.igap.net/pec-qr/v1.0";
export const NEWS_BASEURL = "https://api.cafetitle.com";
export const AI_BASEURL = "https://ai.igap.net";

/* WEBSERVICES */

//AI
export const AI_GET_TOKEN = `${AI_BASEURL}/auth/token/`;
export const AI_TEXT_TO_VOICE = `${AI_BASEURL}/api/v1/voice/tts/`;
export const AI_GRANT_TYPE = "password";
export const AI_CLIENT_ID = "AOiVyGdhud8dLZuBRfnK9to3ndhKfetMffRXFnWu";
export const AI_USER_NAME = "igap";
export const AI_PASSWORD = "Zvbifr5jD8KC6ty";

export const FILE_UPLOAD = `${FILE_BASEURL}/upload/{{token}}`;
export const FILE_INIT_UPLOAD = `${FILE_BASEURL}/init`;
export const FILE_INIT_RESUME = `${FILE_BASEURL}/init/{{token}}`;
export const FILE_DOWNLOAD = `${FILE_BASEURL}/download/{{token}}?selector={{selector}}`;
export const STICKER_CATEGORIES = `${STICKER_BASEURL}/category`;
export const STICKER_CATEGORY = `${STICKER_CATEGORIES}/{{categoryId}}?skip={{skip}}`;
export const STICKER_CONFIGS = `${STICKER_BASEURL}/main/configs`;
export const STICKER_FILTER_CATEGORY = `${STICKER_CATEGORIES}/{{categoryId}}?skip={{skip}}&type={{type}}`;
export const STICKER_GROUP = `${STICKER_BASEURL}/main/{{groupId}}`;
export const STICKER_USER_LIST = `${STICKER_BASEURL}/user-list`;
export const STICKER_USER_LIST_ADD = `${STICKER_USER_LIST}/{{groupId}}`;
export const STICKER_USER_LIST_DELETE = `${STICKER_USER_LIST}/delete`;
export const ILAND_CONFIG_CHARGE = `${ILAND_BASEURL}/configs`;
export const ILAND_TOPUP_PURCHASE = `${ILAND_BASEURL}/{{operator}}/topup/purchase`;
export const ILAND_BILL_MANAGER_BASE_URL = "https://api.igap.net/bill-manager/v1.0";
export const ILAND_BILL_GET_TYPE = `${ILAND_BILL_MANAGER_BASE_URL}/info/get-types`;
export const ILAND_GET_INQUIRY = `${ILAND_BILL_MANAGER_BASE_URL}/get-inquiry`;
export const ILAND_ADD_BILL = `${ILAND_BILL_MANAGER_BASE_URL}/add-bill`;
export const ILAND_GET_BILLS = `${ILAND_BILL_MANAGER_BASE_URL}/get-bills?skip={{skip}}&limit={{limit}}`;
export const ILAND_DELETE_BILL = `${ILAND_BILL_MANAGER_BASE_URL}/delete-bill/{{billId}}`;
export const ILAND_EDIT_BILL = `${ILAND_BILL_MANAGER_BASE_URL}/edit-bill/{{billId}}`;
export const ILAND_GET_BILL_IMAGE = `${ILAND_BILL_MANAGER_BASE_URL}/get-last-bill-image`;
export const ILAND_GET_DETAILS = `${ILAND_BILL_MANAGER_BASE_URL}/get-details`;
export const ILAND_CHECK_ORDER = `${PAYMENT_BASEURL}/order-check/{{token}}`;
export const ILAND_ORDER_APPROVAL = `${PAYMENT_BASEURL}/order-approval`;
export const ILAND_CHARITY = `${SERVICES_BASEURL}/charity/help/{{amount}}`;
export const IGAST_GET_PROVINCE = `${IGAST_BASEURL}/entertainment/province`;
export const GET_LOCATION_SEARCH = `${IGAST_BASEURL}/entertainment/location/{{locationId}}`;
export const IGASHT_GET_SERVICE_LIST = `${IGAST_BASEURL}/entertainment/service/{{serviceId}}`;
export const IGASHT_TICKET_PURCHASE = `${IGAST_BASEURL}/entertainment/purchase`;
export const IGASHT_TICKET_LIST = `${IGAST_BASEURL}/entertainment/ticket/list?skip={{skip}}&limit={{limit}}`;
export const IGASHT_TICKET_QRCODE = `${IGAST_BASEURL}/entertainment/ticket/qr-code/{{ticketId}}`;

/* CHANNELS */
export const ILAND_CHANNELS = `${SERVICES_BASEURL}/channel`;
export const ILAND_CHANNELS_CATEGORY = `${SERVICES_BASEURL}/channel/category/{{channelsId}}`;

/* Shahkar */
export const SHAHKAR_CHECK_MOBILE_NUMBER_USER = `${EXTERNAL_BASEURL}/shahkar/users/check-mobile-number`;
export const SHAHKAR_CHECK_MOBILE_NUMBER_SERVERS = `${EXTERNAL_BASEURL}/shahkar/clients/check-mobile-number`;

/* GIFT STICKER */
export const STICKER_GIFT_FIRSTPAGE = `${STICKER_BASEURL}/gift/first-page`;
export const STICKER_GIFT_LIST = `${STICKER_BASEURL}/gift/giftable-list`;
export const STICKER_GIFT_ISSUE = `${STICKER_BASEURL}/gift/issue/{{stickerId}}`;
export const STICKER_GIFT_USER_LIST = `${STICKER_BASEURL}/gift/user-list`;
export const STICKER_GIFT_CARD_INFO = `${STICKER_BASEURL}/gift/card-info/{{giftId}}`;
export const STICKER_GIFT_ACTIVATED_LIST = `${STICKER_BASEURL}/gift/activated-list`;
export const STICKER_GIFT_ACTIVE = `${STICKER_BASEURL}/gift/activate/{{giftStickerId}}`;

/* INTERNET PACKAGE */
export const INTERNET_PACKAGE_CHARGES = `${SERVICES_BASEURL}/internet-package/charge-types`;
export const INTERNET_PACKAGE_CATEGORIES = `${SERVICES_BASEURL}/internet-package/categories`;
export const INTERNET_PACKAGE_CATEGORIZED = `${SERVICES_BASEURL}/{{operator}}/internet-package/packages/categorized`;
export const INTERNET_PACKAGE_PURCHASE = `${SERVICES_BASEURL}/{{operator}}/internet-package/purchase`;

/* News */
const NEWS_TOKEN = "08a2e396-6a3a-45b8-be63-fe0cf11fdf55";
export const NEWS_GET_SERVICES = `${NEWS_BASEURL}/getServices/${NEWS_TOKEN}/`;
export const NEWS_GET_LAST_NEWS_LIST = `${NEWS_BASEURL}/getLastNewsList/${NEWS_TOKEN}/?page={{page}}&perpage={{perPage}}&serviceId={{serviceId}}`;
export const NEWS_GET_HIT_NEWS_LIST = `${NEWS_BASEURL}/getHitNewsList/${NEWS_TOKEN}/?page={{page}}&perpage={{perPage}}&serviceId={{serviceId}}`;
export const NEWS_GET_HIGHLY_CONTROVERSIAL_NEWS_LIST = `${NEWS_BASEURL}/getHighlyControversialNewsList/${NEWS_TOKEN}/?page={{page}}&perpage=10&{{serviceId}}`;
export const NEWS_GET_FEATURED_NEWS_LIST = `${NEWS_BASEURL}/getFeaturedNewsList/${NEWS_TOKEN}/`;
export const NEWS_GET_URGENT_NEWS_LIST = `${NEWS_BASEURL}/getUrgentNewsList/${NEWS_TOKEN}/`;
export const NEWS_GET_NEWS_LIST = `${NEWS_BASEURL}/getNewsList/08a2e396-6a3a-45b8-be63-fe0cf11fdf55/?page={{page}}&perpage=10&serviceId=10`;
export const NEWS_GET_NEWS = `${NEWS_BASEURL}/getNews/08a2e396-6a3a-45b8-be63-fe0cf11fdf55/`;
export const NEWS_GET_NEWS_COMMENTS = `${NEWS_BASEURL}/getNewsComments/${NEWS_TOKEN}/?page={{page}}&perpage=10&articleid={{articleId}}`;
export const NEWS_SET_COMMENT = `${NEWS_BASEURL}/setComment/${NEWS_TOKEN}/`;
export const NEWS_GET_SOURCES = `${NEWS_BASEURL}/getSources/${NEWS_TOKEN}/`;
export const NEWS_GET_SOURCE_NEWS_LIST = `${NEWS_BASEURL}/getSourceNewsList/${NEWS_TOKEN}/`;
export const NEWS_GET_FIRST_PAGE_DATA = `${NEWS_BASEURL}/getFirstPageData/${NEWS_TOKEN}/`;
export const NEWS_GET_RELATED_NEWS_LIST = `${NEWS_BASEURL}/getRelatedNewsList/${NEWS_TOKEN}/`;

/* PEC QR */
export const PEC_GET_INFO = `${PEC_QR_BASEURL}/merchants/{{qrCode}}`;
export const PEC_MONEY_TRANSFER = `${PEC_QR_BASEURL}/merchants/money-transfer`;
